import { ArrowLeft, Clock } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ConfirmationsListView } from "@/domains/appointment/new-calendar/components/list-view/confirmations-list-view";
import { useConfirmationsAppointments } from "@/domains/appointment/new-calendar/hooks/use-confirmations-appointments";
import { ErrorAlert } from "@/lib/components/error-alert";
import { BaseNavigationBar } from "@/lib/components/navigation";
import { PageContent } from "@/lib/components/page-content";

export function ConfirmationPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("newCalendar");

  const { appointments, loading, error } = useConfirmationsAppointments();

  const handleBackToCalendar = () => {
    navigate("/appointments");
  };

  // Generate subtitle with pending count
  const subtitle = useMemo(() => {
    const count = appointments.length;
    if (count === 0) {
      return t("confirmations.noAppointments");
    }
    return t("confirmations.subtitle", { count });
  }, [appointments.length, t]);

  return (
    <>
      <BaseNavigationBar
        title={t("confirmations.title")}
        subtitle={subtitle}
        backButton={
          <Button variant="ghost" size="sm" onClick={handleBackToCalendar} className="gap-2">
            <ArrowLeft className="h-4 w-4" />
          </Button>
        }
      />

      <PageContent>
        <div className="space-y-6">
          <ErrorAlert error={error} />

          {loading ? (
            <div className="flex items-center justify-center py-12">
              <div className="flex items-center gap-3 text-muted-foreground">
                <Clock className="h-5 w-5 animate-pulse" />
                <span>{t("confirmations.loading")}</span>
              </div>
            </div>
          ) : (
            <ConfirmationsListView />
          )}
        </div>
      </PageContent>
    </>
  );
}
